import { ProductCategory } from "@utils/constants";

type SearchResultViewType = Record<
  ProductCategory,
  SearchResultsAndFavoritesEnum
>;

enum SearchResultsAndFavoritesEnum {
  VIEW_DETAILS = "view_details",
  SHARE_EMAIL = "share_via_email",
  SHARE_EMAIL_EXCEL_PDF = "share_email_excel_pdf",
  SHARE_NATIVE = "share_via_native",
  SHARE_MEDIA = "share_media",
  ADD_TO_FAVORITES = "add_to_favorites",
  ADD_TO_COLLECTION = "add_to_collection",
  REQUEST_ITEMS = "request_items",
  GRID = "grid",
  LIST = "list",
  LIST_EXPANDED = "list_expanded",
  CHANGE_VIEW = "change_view",
  SAVE_SEARCH = "save_search",
  FILTERS = "filters",
  SORTING = "sorting",
  CUSTOM_COLUMN = "custom_column",
  MOVE_TO_ANOTHER_COLLECTION = "move_to_another_collection",
  MOVE_TO_A_COLLECTION = "move_to_a_collection",
  REMOVE_FROM_COLLECTION = "remove_from_collection",
  REMOVE_FROM_FAVORITES = "remove_from_favorites",
  VIDEO_ONLY = "video_only",
  BULK_ACTION = "bulkaction",
  PAGE_SIZE = 24,
  WEB_LIST_PAGE_SIZE = 30,
  ADD = "add",
  REMOVE = "remove",
  HEARTS_AND_ARROWS = "hearts_and_arrows",
  TREATMENT = "treatment",
  HEARTS_AND_ARROWS_VALUE = "Hearts and Arrows",
  ADD_TO_BULK_REQUEST = "add_to_bulk_request",
  REMOVE_FROM_BULK_REQUEST = "remove_from_bulk_request",
  ADD_TO_BULK_LIST = "add_to_bulk_list",
  BUY_ITEMS = "buy",
  MEMO_ITEMS = "memo",
  HOLD_ITEMS = "hold",
  DOWNLOAD_CSV_PDF = "download_csv_pdf",
  CUSTOM_COLUMN_SEARCH_RESULT = "custom_column-SearchResult",
  SORTING_SEARCH_RESULT = "sorting-SearchResult",
  ADD_TO_CART = "add_to_cart",
  REQUEST_NOW = "request_now",
  ORDER_NOW = "order_now",
  BUY_NOW = "buy_now",
  SEND_QUOTE = "send_quote",
  SHARE_VIA_LINK = "share_via_link",
}

const SEARCH_RESULT_VIEW_TYPE: SearchResultViewType = {
  [ProductCategory.DIAMOND]: "",
  [ProductCategory.GEMSTONE]: "",
  [ProductCategory.JEWELRY]: "",
  [ProductCategory.LABGROWN_JEWELRY]: "",
  [ProductCategory.LAB_GROWN_DIAMOND]: "",
  [ProductCategory.DEFAULT]: "",
};

const INITIAL_SEARCH_RESULT_VIEW_TYPE = {
  [ProductCategory.DIAMOND]: false,
  [ProductCategory.GEMSTONE]: false,
  [ProductCategory.JEWELRY]: false,
  [ProductCategory.LABGROWN_JEWELRY]: false,
  [ProductCategory.LAB_GROWN_DIAMOND]: false,
  [ProductCategory.DEFAULT]: false,
};

const FALLBACK_IMAGE_ASSET =
  "https://all-demos.s3.amazonaws.com/vdb-app-landing/img/image.png";

enum CartTypeEnum {
  BULK_REQUEST_TYPE = "request",
  SHOPPING_CART_TYPE = "retail_order",
  ORDER_CART = "order_cart",
}

enum BulkActionsEnum {
  BULK_REQUEST_ACTION = "bulk_request",
  REQUEST_NOW_ACTION = "instant_request",
  EMAIL_EXCEL_PDF = "email_selected_items",
}

enum SearchResultsScreenModals {
  SHARE = "share",
  COLLECTIONS_LIST = "collections_list",
  CREATE_NEW_COLLECTION = "create_new_collection",
  LOADER_MODAL = "loader_modal",
  EMAIL_EXCEL_MODAL = "email_modal",
  DOWNLOAD_CSV_PDF = "download_csv_pdf",
}

export {
  SearchResultViewType,
  SearchResultsAndFavoritesEnum,
  SEARCH_RESULT_VIEW_TYPE,
  INITIAL_SEARCH_RESULT_VIEW_TYPE,
  FALLBACK_IMAGE_ASSET,
  CartTypeEnum,
  BulkActionsEnum,
  SearchResultsScreenModals,
};
